import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20floating%20in%20warm%20abstract%20space%20with%20coral%20and%20golden%20gradients%2C%20screen%20displaying%20elegant%20video%20streaming%20interface%20mockup%2C%20minimalist%20tech%20aesthetic%2C%20no%20text%2C%20soft%20warm%20atmospheric%20lighting&width=800&height=600&seq=app-mobile-2026&orientation=landscape"
                alt="芭乐视频移动端观影体验"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
              移动观影
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {appInfo.title}
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              {appInfo.desc}
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8">
              {appInfo.features.map((f) => (
                <div
                  key={f}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200"
                >
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line text-lg"></i>
                手机端打开
              </button>
              <button className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium rounded-lg text-sm border border-background-300 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-computer-line text-lg"></i>
                电脑端观看
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}